
import {css} from "lit"
export default css`

:host {
	display: block;
}

slot {
	display: block;
	margin-bottom: 2em;
}

`

